<template>
    <div class="beneficios">
        <div id="beneficios" class="ancla"></div>
        <div class="content">
            <div class="titulo">
                <b-row>
                    <b-col cols="12" md>
                        <div class="linea lineaIzquierda"></div>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <p v-if="lang == 'eng'">benefits</p>
                        <p v-else-if="lang == 'esp'">beneficios</p>
                    </b-col>
                    <b-col cols>
                        <div class="linea lineaDerecha"></div>
                    </b-col>
                </b-row>
            </div>
            <b-row>
                <b-col cols="6" md="4" lg="3" offset-lg="1" class="contentServicio">
                    <div class="servicio">
                        <div class="img">
                            <img src="../assets/img/icn_service1.svg" alt="Servicio">
                        </div>
                        <p v-if="lang == 'eng'">Key Strategic locations at the most visited border ports</p>
                        <p v-else-if="lang == 'esp'">Ubicaciones estratégicas en los puertos fronterizos más visitado del mundo</p>
                    </div>
                </b-col>
                    <b-col cols="6" md="4" lg="3" class="contentServicio">
                    <div class="servicio">
                        <div class="img">
                            <img src="../assets/img/icn_service2.svg" alt="Servicio">
                        </div>
                        <p v-if="lang == 'eng'">Captive<br>Audience</p>
                        <p v-else-if="lang == 'esp'">Audiencia<br>Cautiva</p>
                    </div>
                </b-col>
                <b-col cols="6" md="4" lg="3" class="contentServicio">
                    <div class="servicio">
                        <div class="img">
                            <img src="../assets/img/icn_service3.svg" alt="Servicio">
                        </div>
                        <p v-if="lang == 'eng'">Dual market view<br>Tijuana - San Diego</p>
                        <p v-else-if="lang == 'esp'">Vista dual mercado<br>Tijuana - San Diego</p>
                    </div>
                </b-col>
                <b-col cols="6" md="4" lg="3" class="contentServicio">
                    <div class="servicio">
                        <div class="img">
                            <img src="../assets/img/icn_service4.svg" alt="Servicio">
                        </div>
                        <p v-if="lang == 'eng'">Custom<br>build plans</p>
                        <p v-else-if="lang == 'esp'">Planes a<br>la medida</p>
                    </div>
                </b-col>
                <b-col cols="6" md="4" lg="3" class="contentServicio">
                    <div class="servicio">
                        <div class="img">
                            <img src="../assets/img/icn_service6.svg" alt="Servicio">
                        </div>
                        <p v-if="lang == 'eng'">P8 digital displays with better short definition and long distance</p>
                        <p v-else-if="lang == 'esp'">Pantallas digitales P8 con mejor definición a corta y larga distancia</p>
                    </div>
                </b-col>
           </b-row>
        </div> 
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    export default {
        computed:{
            ...mapState(['lang'])
        }
    }
</script>

<style scoped>
    .beneficios{
        position: relative;
        padding: 140px 0 50px 0;
        background-image: url('../assets/img/img_background_color.jpg');
        background-size: 75%;
        background-position: left bottom;
        background-repeat: no-repeat;
    }
    .row{
        justify-content: center;
    }
    .text{
        display: flex;
        align-items: center;
        height: 100%;
    }
    .text h2{
        max-width: 400px;
    }
    .text p{
        max-width: 500px;
        margin-top: 20px;
    }
    .contentServicio{
        padding: 15px;
    }
    .servicio{
        background-color: white;
        height: 100%;
        text-align: center;
        padding: 40px 40px;
        min-height: 260px;
        -webkit-box-shadow: 0px 10px 30px 0px rgba(136,26,0,1);
        -moz-box-shadow: 0px 10px 30px 0px rgba(136,26,0,1);
        box-shadow: 0px 10px 30px 0px rgba(136,26,0,1);
    }
    .servicio p{
        color: black;
    }
    .img{
        width: 50%;
        min-width: 60px;
        margin: 0 auto 20px auto;
    }
    img{
        width: 100%;
    }
    p{
        margin: 0;
    }

    @media screen and (max-width: 991px){
        .text{
            margin-bottom: 40px;
        }
    }
    @media screen and (max-width: 767px){
        .beneficios{
            padding: 100px 0 0 0;
            background-size: 90%;
            background-position: left 80%;
        }
        .servicio{
            padding: 20px 10px;
            min-height: inherit;
        }
        .servicio p{
            font-size: 10pt;
        }
        .img{
            width: 60%;
            min-width: inherit;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Beneficios.vue